// src/app/firebase.tokens.ts

import { InjectionToken } from '@angular/core';
import { Firestore, getFirestore } from 'firebase/firestore';
import { FirebaseStorage, getStorage } from 'firebase/storage';

export const FIRESTORE_TOKEN = new InjectionToken<Firestore>('Firestore Instance', {
  providedIn: 'root',
  factory: () => getFirestore(),
});

export const STORAGE_TOKEN = new InjectionToken<FirebaseStorage>('Firebase Storage Instance', {
  providedIn: 'root',
  factory: () => getStorage(),
});
